module.exports = __webpack_public_path__ + "img/cross.d36ab6af.png";